// src/hooks/useAutoResizeTextarea.ts
import { useEffect, RefObject } from 'react';

export function useAutoResizeTextarea(textareaRef: RefObject<HTMLTextAreaElement>) {
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return; // Safely handle null case

    const adjustHeight = () => {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    };

    // Set initial height
    adjustHeight();

    // Add event listeners for input
    textarea.addEventListener('input', adjustHeight);

    // Clean up
    return () => {
      textarea.removeEventListener('input', adjustHeight);
    };
  }, [textareaRef]);
}